const MENTIONS_PREF_KEY = 'acor_notifications_only_mentions';
const MENTIONS_PREF_EVENT = 'acor:notifications:mentions-pref';
const OBRAS_PREF_KEY = 'acor_notification_preferred_obras';
const OBRAS_PREF_EVENT = 'acor:notifications:preferred-obras';
const COUNTERS_REFRESH_EVENT = 'acor:notifications:refresh-counters';

export const notificationsPreferences = {
  mentionsKey: MENTIONS_PREF_KEY,
  mentionsEvent: MENTIONS_PREF_EVENT,
  preferredObrasKey: OBRAS_PREF_KEY,
  preferredObrasEvent: OBRAS_PREF_EVENT,
  refreshCountersEvent: COUNTERS_REFRESH_EVENT,
};

export function readMentionsPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(MENTIONS_PREF_KEY) === '1';
  } catch {
    return false;
  }
}

export function persistMentionsPreference(value: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(MENTIONS_PREF_KEY, value ? '1' : '0');
  } catch {
    // ignore write errors (private mode, etc.)
  }
  try {
    window.dispatchEvent(new CustomEvent(MENTIONS_PREF_EVENT, { detail: value }));
  } catch {
    // ignore dispatch issues in non-browser envs
  }
}

export function readPreferredObras(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const stored = window.localStorage.getItem(OBRAS_PREF_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed)
      ? (parsed.filter((id: unknown) => typeof id === 'string') as string[])
      : [];
  } catch {
    return [];
  }
}

export function persistPreferredObras(ids: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    const clean = (ids ?? []).filter((id): id is string => typeof id === 'string' && id.length > 0);
    window.localStorage.setItem(OBRAS_PREF_KEY, JSON.stringify(clean));
    window.dispatchEvent(new CustomEvent(OBRAS_PREF_EVENT, { detail: clean }));
  } catch {
    // silently ignore storage/dispatch failures
  }
}

export function dispatchNotificationCountersRefresh(): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new Event(COUNTERS_REFRESH_EVENT));
  } catch {
    // ignore dispatch failures
  }
}
